import React from "react"
import Head from "next/head"

import { Layout } from "components/features/layout"
import { withAuth } from "components/hoc/withAuth"
import { PageHeader } from "components/page/PageHeader"
import { useMe } from "lib/hooks/useMe"

function Home() {
  const { me } = useMe()

  return (
    <Layout>
      <Head>
        <title>Supliful Dashboard</title>
      </Head>

      <PageHeader
        title={`Welcome${me ? `, ${me.firstName} ${me.lastName}` : ""}`}
      />
    </Layout>
  )
}

export default withAuth(Home)
